import React, { useEffect } from 'react';
import NavBar from './NavBar';
import './Tools.css';

function Tools() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="tools-page">
      <NavBar />

      <section className="tools-hero">
        <div className="tools-hero-content">
          <h1>Tools</h1>
          <p className="tools-subtitle">Built-in tools and custom toolkits for specialized domains</p>
        </div>
      </section>

      <div className="tools-content">
        {/* Built-in Tools Section */}
        <section className="tools-section">
          <div className="tools-container">
            <h2>Built-in Tools</h2>
            <p className="section-description">
              Orchestral AI comes with a comprehensive set of built-in tools for common tasks.
            </p>

            <div className="tools-category">
              <h3>Frontend Tools</h3>
              <ul className="tools-list">
                <li><code>DisplayImageTool</code> - Display images in the UI</li>
              </ul>
            </div>

            <div className="tools-category">
              <h3>Filesystem Tools</h3>
              <ul className="tools-list">
                <li><code>ReadFileTool</code> - Read file contents</li>
                <li><code>WriteFileTool</code> - Write data to files</li>
                <li><code>EditFileTool</code> - Edit existing files</li>
                <li><code>ListDirectoryTool</code> - List directory contents</li>
                <li><code>FileSearchTool</code> - Search for files by pattern</li>
                <li><code>FindFilesTool</code> - Find files in directory structures</li>
              </ul>
            </div>

            <div className="tools-category">
              <h3>Terminal Tools</h3>
              <ul className="tools-list">
                <li><code>RunCommandTool</code> - Execute shell commands</li>
                <li><code>DummyRunCommandTool</code> - For testing security features</li>
              </ul>
            </div>

            <div className="tools-category">
              <h3>Python Execution</h3>
              <ul className="tools-list">
                <li><code>RunPythonTool</code> - Execute Python code dynamically</li>
              </ul>
            </div>

            <div className="tools-category">
              <h3>Web Tools</h3>
              <ul className="tools-list">
                <li><code>WebSearchTool</code> - Search the web for information</li>
              </ul>
            </div>

            <div className="tools-category">
              <h3>Task Management</h3>
              <ul className="tools-list">
                <li><code>TodoRead</code> - Read task lists</li>
                <li><code>TodoWrite</code> - Create and update task lists</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Custom Toolkits Section */}
        <section className="tools-section">
          <div className="tools-container">
            <h2>Custom Toolkits</h2>
            <p className="section-description">
              Specialized toolkits for domain-specific research and applications.
            </p>

            <div className="toolkit-grid">
              {/* ASTER */}
              <div className="toolkit-card">
                <div className="toolkit-image-container">
                  <img src="/aster_toolkit_logo.png" alt="ASTER Toolkit" className="toolkit-image" />
                </div>
                <h3>ASTER</h3>
                <p className="toolkit-subtitle">Agentic Science Toolkit for Exoplanet Research</p>
                <p>
                  Specialized tools for exoplanet discovery and characterization, including data analysis,
                  visualization, and automated hypothesis generation.
                </p>
              </div>

              {/* HEP Toolkit */}
              <div className="toolkit-card">
                <div className="toolkit-image-container">
                  <img src="/heptapod_paper_header.png" alt="HEP Toolkit" className="toolkit-image" />
                </div>
                <h3>HEP Toolkit</h3>
                <p className="toolkit-subtitle">Toolkit for Event Generation and Analysis in High Energy Physics</p>
                <p>
                  Tools for particle physics research, enabling automated event generation, simulation,
                  and analysis workflows for HEP experiments.
                </p>
              </div>

              {/* QML Toolkit */}
              <div className="toolkit-card">
                <div className="toolkit-image-container">
                  <img src="/quantum_circuit.png" alt="QML Toolkit" className="toolkit-image" />
                </div>
                <h3>QML Toolkit</h3>
                <p className="toolkit-subtitle">Toolkit for agentic exploration and testing of Variational Quantum Circuits</p>
                <p>
                  Tools for quantum machine learning research, supporting the design, testing, and
                  optimization of VQC architectures.
                </p>
              </div>

              {/* Bayesian Agents */}
              <div className="toolkit-card">
                <h3>Bayesian Agents</h3>
                <p className="toolkit-subtitle">Details coming soon</p>
                <p>
                  Advanced toolkit for Bayesian reasoning and probabilistic agent-based systems.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Tools;
